<div *withPermissions="let allow of ['CanViewCustomReports', 'CanViewCustomActions', 'CanUpdateAdvancedSettings', 'CanRepublishBlogs', 'CanManageCustomerCampaign']">
	<app-components-managecustomer-floatingcustomernote
		[customerId]="customerId"
		(floatingNoteSaved)="reloadNotes()">
	</app-components-managecustomer-floatingcustomernote>
	<app-components-managecustomer-floatingcustomertodolist [customer]="customer"></app-components-managecustomer-floatingcustomertodolist>
	<app-components-managecustomer-connecteduserssidepanel [customerId]="customerId"></app-components-managecustomer-connecteduserssidepanel>
	<div class="card">
		<div class="card-header">
				<strong>{{partnerName}}</strong>
				— Customer Information
				<button (click)="close()" class="btn-close" title="Close"></button>
		</div>
		<ng-container *ngIf="customer && partner">
      <app-components-managecustomer-customerinformation
				[customer]="customer"
				[partner]="partner"
				page="ManageCustomer"
				[showStoreLink]="showStoreLink"
        (pageChangeEvent)="openTab($event)">
      </app-components-managecustomer-customerinformation>
		</ng-container>
	</div>
	@if (!isLoading) {
	<app-tab-panel [displayMode]="tabPanelDisplayMode.smallVertical">
		<app-dynamic-tab  title="Notes and Tickets">
			<app-components-managecustomer-notesandtickets *tabContent
				[customer]="customer"
				(refreshCustomer)="refreshCustomer()">
			</app-components-managecustomer-notesandtickets>
		</app-dynamic-tab>
		<app-dynamic-tab title="Basic Information">
			<compose *tabContent Selector="app-components-managecustomer-basicinformation" [ActivateOptions]="{
				customer: customerObservable,
				refreshCustomer: refreshCustomer.bind(this)
			}"></compose>
		</app-dynamic-tab>
		<app-dynamic-tab title="To Do History">
			<compose *tabContent Selector="app-components-managecustomer-customertodohistory" [ActivateOptions]="{
				customer: customerObservable
			}"></compose>
		</app-dynamic-tab>
		@if (!hasOnlyEverHadBusinessProfileManagement) {
		<app-dynamic-tab title="SEO Content Survey">
			<compose *tabContent Selector="app-components-managecustomer-seocontentsurvey" [ActivateOptions]="{
				customer: customerObservable
			}"></compose>
		</app-dynamic-tab>
		}
		<app-dynamic-tab title="Customer Contact">
			<app-components-managecustomer-customerusers *tabContent
				[customer]="customer"
				[user]="user"
				[partner]="partner"
				(refreshCustomer)="refreshCustomer()">
			</app-components-managecustomer-customerusers>
		</app-dynamic-tab>
		<app-dynamic-tab title="Reporting Dashboard Access">
			<app-components-managecustomer-reporting-dashboard-access *tabContent
				[user]="user"
				[partner]="partner"
				[customer]="customer"
				(refreshCustomer)="refreshCustomer()">
			</app-components-managecustomer-reporting-dashboard-access>
		</app-dynamic-tab>
		<app-dynamic-tab title="Logins &amp; Google Setup">
			<compose *tabContent Selector="app-components-managecustomer-logins-and-google-setup" [ActivateOptions]="{
				customer: customerObservable,
				refreshCustomer: refreshCustomer.bind(this)
			}"></compose>
		</app-dynamic-tab>
		@if (allow()['CanManageCustomerCampaign']() && !hasOnlyEverHadBusinessProfileManagement) {
		<app-dynamic-tab title="Customer Campaign">
			<compose *tabContent Selector="app-components-managecustomer-customer-campaign" [ActivateOptions]="{
				customer: customerObservable,
				refreshCustomer: refreshCustomer.bind(this),
				getRefreshedCustomer: getRefreshedCustomer.bind(this)
			}"></compose>
		</app-dynamic-tab>
		}
		<app-dynamic-tab title="Local Profile">
			<compose *tabContent Selector="app-components-managecustomer-local-profiles" [ActivateOptions]="{
				customer: customerObservable
			}"></compose>
		</app-dynamic-tab>
		@if (hasWebsite) {
		<app-dynamic-tab title="Websites">
			<compose *tabContent Selector="app-components-websites" [ActivateOptions]="{
				customer: customerObservable
			}"></compose>
		</app-dynamic-tab>
		}
		<app-dynamic-tab title="Work History">
			<compose *tabContent Selector="app-components-managecustomer-customerworkhistory" [ActivateOptions]="{
				customer: customerObservable
			}"></compose>
		</app-dynamic-tab>
		@if (!this.hasOnlyEverHadBusinessProfileManagement || this.partnerSupportsReceipts) {
			<app-dynamic-tab title="Files">
				<compose *tabContent Selector="app-components-managecustomer-files" [ActivateOptions]="{
					customer: customerObservable
				}"></compose>
			</app-dynamic-tab>
			@if (allow()['CanRepublishBlogs']()) {
			<app-dynamic-tab title="Published Custom Blogs">
				<compose *tabContent Selector="app-components-managecustomer-blogposts" [ActivateOptions]="{
					customer: customerObservable
				}"></compose>
			</app-dynamic-tab>
			}
			@if (allow()['CanUpdateAdvancedSettings']()) {
			<app-dynamic-tab title="Allocate Work">
				<app-components-managecustomer-allocate-work *tabContent
					[customer]="customer"
					[partner]="partner"
					[partnerUser]="partnerUser"
					[user]="user"
					(refreshCustomer)="refreshCustomer()">
				</app-components-managecustomer-allocate-work>
			</app-dynamic-tab>
			}
		}
	</app-tab-panel>
	}
	<div id="activationModal" class="modal fade" role="dialog">
		<div class="modal-dialog modal-dialog-centered" role="document">
			<div class="modal-content">
				<div class="modal-body">
					<span>Remember to configure the products in the Billing and Products screen after activating the customer.</span>
				</div>
				<div class="modal-footer">
					<button (click)="redirectToConfigureProducts()" type="button" class="btn btn-primary">Configure Products</button>
					<button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
				</div>
			</div>
		</div>
	</div>
</div>
